import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import AboutPage from "@/pages/AboutPage";
import EventDetailPage from "@/pages/EventDetailPage";
import SuccessPage from "@/pages/SuccessPage";
import CancelPage from "@/pages/CancelPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import EventFormPage from "@/pages/EventFormPage";
import AttendeesPage from "@/pages/AttendeesPage";
import NYCLaunchPage from "@/pages/NYCLaunchPage";
import LaunchTeamPage from "@/pages/LaunchTeamPage";
import VisitInfoPage from "@/pages/VisitInfoPage";
import VisitInfoAdminPage from "@/pages/VisitInfoAdminPage";

import { usePageTracking } from "@/hooks/usePageTracking";

function Layout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  usePageTracking();
  
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {!isAdmin && <Navbar />}
      <main className="flex-1">
        {children}
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/revival-night" element={<CategoryPage category="Revival Night" />} />
          <Route path="/prophetic-school" element={<CategoryPage category="Prophetic School" />} />
          <Route path="/mentorship" element={<CategoryPage category="Mentorship" />} />
          <Route path="/nyc-launch" element={<NYCLaunchPage />} />
          <Route path="/visit" element={<VisitInfoPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/events/:id" element={<EventDetailPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/analytics" element={<AnalyticsPage />} />
          <Route path="/admin/launch-team" element={<LaunchTeamPage />} />
          <Route path="/admin/visit-info" element={<VisitInfoAdminPage />} />
          <Route path="/admin/events/new" element={<EventFormPage />} />
          <Route path="/admin/events/:id/edit" element={<EventFormPage />} />
          <Route path="/admin/events/:eventId/attendees" element={<AttendeesPage />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
